import SectionHeading from "@/components/base/SectionHeading";
import { ratingBoard } from "@/mocks/highlights";
import { dramas } from "@/mocks/dramas";

const trendStyle: Record<string, string> = {
  上升: "text-primary-600",
  持平: "text-foreground-500",
  下降: "text-secondary-500",
  新上榜: "text-accent-700",
  口碑榜: "text-accent-700",
};

const hotActors = ["车瑞妍", "李道勋", "金慕妍", "郑宇彬", "徐河准", "吴世琳", "姜泰允", "裴书俊"];

export default function RankingSection() {
  const maxHeat = Math.max(...dramas.map((d) => d.heat));

  return (
    <section id="ranking" className="relative w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="收视与热度"
          title="这一季，谁在领跑"
          desc="左边是电视台收视榜，右边是站内讨论热度。收视看「有多少人在看」，热度看「有多少人在聊」，两个角度一起看更全面。"
          accent="secondary"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-7 reveal rounded-2xl border border-background-200 bg-background-50 overflow-hidden">
            <div className="px-5 md:px-6 py-4 border-b border-background-200 flex items-center gap-2">
              <i className="ri-bar-chart-2-line text-primary-500"></i>
              <h3 className="font-heading font-semibold text-foreground-950">电视台收视排行</h3>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full min-w-[520px] text-sm">
                <thead>
                  <tr className="text-left text-xs text-foreground-500 font-label">
                    <th className="px-5 md:px-6 py-3 font-medium w-14">排名</th>
                    <th className="px-3 py-3 font-medium">剧集</th>
                    <th className="px-3 py-3 font-medium">频道</th>
                    <th className="px-3 py-3 font-medium">收视</th>
                    <th className="px-5 md:px-6 py-3 font-medium">走势</th>
                  </tr>
                </thead>
                <tbody>
                  {ratingBoard.map((row) => (
                    <tr
                      key={row.title}
                      className="border-t border-background-100 hover:bg-background-100/70 transition-colors"
                    >
                      <td className="px-5 md:px-6 py-3.5">
                        <span
                          className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-label font-medium ${
                            row.rank <= 3
                              ? "bg-primary-500 text-background-50"
                              : "bg-background-200 text-foreground-700"
                          }`}
                        >
                          {row.rank}
                        </span>
                      </td>
                      <td className="px-3 py-3.5 font-medium text-foreground-900">
                        《{row.title}》
                        <span className="ml-2 text-xs text-foreground-400 font-normal">{row.year}</span>
                      </td>
                      <td className="px-3 py-3.5 text-foreground-600 text-xs">{row.channel}</td>
                      <td className="px-3 py-3.5 font-heading font-semibold text-foreground-950">
                        {row.rating}
                      </td>
                      <td className={`px-5 md:px-6 py-3.5 text-xs font-label ${trendStyle[row.trend]}`}>
                        {row.trend}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="lg:col-span-5 reveal rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="flex items-center gap-2 mb-5">
              <i className="ri-fire-line text-accent-500"></i>
              <h3 className="font-heading font-semibold text-foreground-950">站内讨论热度</h3>
            </div>
            <ul className="space-y-4">
              {dramas
                .slice()
                .sort((a, b) => b.heat - a.heat)
                .map((drama) => {
                  const pct = Math.round((drama.heat / maxHeat) * 100);
                  return (
                    <li key={drama.id}>
                      <div className="flex items-center justify-between text-sm mb-1.5">
                        <span className="text-foreground-800 truncate">《{drama.title}》</span>
                        <span className="text-xs text-foreground-500 font-label shrink-0 ml-2">
                          {drama.heat.toLocaleString()}
                        </span>
                      </div>
                      <div className="h-2 rounded-full bg-background-200 overflow-hidden">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-accent-500 to-primary-500"
                          style={{ width: `${pct}%` }}
                        ></div>
                      </div>
                    </li>
                  );
                })}
            </ul>

            <div className="mt-6 pt-5 border-t border-background-200">
              <p className="text-xs font-label text-foreground-500 mb-3">热搜演员</p>
              <div className="flex flex-wrap gap-2">
                {hotActors.map((name) => (
                  <span
                    key={name}
                    className="px-3 py-1 rounded-full bg-secondary-50 border border-secondary-100 text-xs text-secondary-800 font-label"
                  >
                    {name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}